import type { FabricEditor } from 'modules/fabric-editor';
import type { ResolverContext } from 'modules/manager/domain/placeholder';

/**
 * Remove any canvas object whose `data.matchNumber` points at a match slot
 * that wasn't provided in the render context. Matches the existing
 * resolver-side drop for placeholders with out-of-range `matchNumber`
 * (`resolver.ts:pickMatchSlot`), extended to plain rect/text objects so
 * authors can per-match-scope decorative elements on multi-match templates.
 *
 * `matchNumber` is 1-based. Values 0/negative/undefined are treated as
 * "unset" (no removal).
 */
export async function filterMatchScopedObjects(
  editor: FabricEditor,
  ctx: Pick<ResolverContext, 'matches'>,
): Promise<void> {
  const matchCount = ctx.matches?.length ?? 0;
  let removed = false;
  for (const obj of [...editor.canvas.getObjects()]) {
    const n = (obj.data as { matchNumber?: number } | undefined)?.matchNumber;
    if (typeof n === 'number' && n >= 1 && n > matchCount) {
      editor.canvas.remove(obj);
      removed = true;
    }
  }
  if (removed) editor.canvas.requestRenderAll();
}
